import React, { forwardRef } from 'react';
import _ from 'lodash';
import { SelectionListMultiSelect } from '../SelectionListMultiSelect';
import cx from 'classnames';
import OpenSelectionList from '../OpenSelectionList';
// eslint-disable-next-line unused-imports/no-unused-imports -- referenced by the props typedef
import SelectionList from '../SelectionList';

/**
 * @typedef {object} OrgUnitSelectorOwnProps
 * @property {Array<*>} organizations
 * @property {(selectedIds: number | Array<number>) => void} [onChange]
 * @property {number|Array<number>} [value]
 */

/**
 * @typedef {OrgUnitSelectorOwnProps &
 *   React.ComponentPropsWithoutRef<typeof SelectionList>} OrgUnitSelectorProps
 */

/**
 * @type {React.ForwardRefExoticComponent<OrgUnitSelectorProps & React.RefAttributes<*>>}
 * @param {OrgUnitSelectorProps} props
 */
export const OrgUnitSelector = forwardRef((props, ref) => {
  const { organizations, multiSelect = true, ...otherProps } = props;

  const options = _.sortBy(getOptions(organizations), o => o.label.toLowerCase());

  return multiSelect ? (
    <SelectionListMultiSelect
      ref={ref}
      {...otherProps}
      id='select-org-unit'
      placeholder='Select Organizational Unit(s)'
      options={options}
    />
  ) : (
    <OpenSelectionList
      ref={ref}
      {...otherProps}
      id='select-org-unit'
      placeholder='Select Organizational Unit'
      list={options}
      multiSelect={false}
      allowAutocomplete={false}
      showInputEndAdornment={false}
    />
  );
});

OrgUnitSelector.displayName = 'OrgUnitSelector';

const getOptions = organizations =>
  organizations.flatMap(o => o.MddapOrgUnits.map(getOrgUnitOption));

const getOrgUnitOption = ou => {
  return {
    label: ou.Name + ' - #' + ou.Fei,
    value: ou.Id,
    labelRendered: renderOptionLabel(ou)
  };
};

const renderOptionLabel = ou => {
  const status = ou.IsActive ? '' : 'De-Enrolled - ';
  return (
    <span className={cx({ italic: !ou.IsActive })}>
      {ou.Name} - {status}#{ou.Fei}
    </span>
  );
};
